var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "50 266 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Auction"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.556 291h-4.167A1.393 1.393 0 0 1 50 289.611v-14.583c0-.764.625-1.39 1.389-1.39h4.167c.763 0 1.388.626 1.388 1.39v14.583A1.393 1.393 0 0 1 55.556 291Z",
    fill: "#ff5f15",
    fillRule: "evenodd",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.611 291h-4.167a1.393 1.393 0 0 1-1.388-1.389v-18.055a1.393 1.393 0 0 1 1.388-1.39h4.167a1.393 1.393 0 0 1 1.389 1.39v18.055c0 .764-.625 1.389-1.389 1.389Z",
    fill: "#ff5f15",
    fillRule: "evenodd",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.583 291h-4.166a1.393 1.393 0 0 1-1.39-1.389V267.39c0-.764.626-1.389 1.39-1.389h4.166a1.393 1.393 0 0 1 1.39 1.389v22.222c0 .764-.626 1.389-1.39 1.389Z",
    fill: "#ff5f15",
    fillRule: "evenodd",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 45"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuction);
export default __webpack_public_path__ + "static/media/auction.e09b98fb.svg";
export { ForwardRef as ReactComponent };